import { Action, createReducer, on } from '@ngrx/store';
import * as SpaycialIntegrationActions from './spaycial-integration-actions';
import { HttpErrorResponse } from '@angular/common/http';

export interface State {
  status: boolean | null;
  scanUser: boolean | null;
  redirectUrl: string | null;
  error: HttpErrorResponse | null;
}

export const initialState: State = {
  status: null,
  scanUser: null,
  redirectUrl: null,
  error: null,
};

export const reducers = createReducer(initialState,
  on(
    SpaycialIntegrationActions.loadStatusSuccess,
    (state: State, { active, scanUser }) => ({ ...state, status: active, scanUser })
  ),
  on(SpaycialIntegrationActions.connectSuccess, (state: State, { redirectUrl }) => ({ ...state, redirectUrl })),
  on(SpaycialIntegrationActions.loadConnectionsSuccess, (state: State, { redirectUrl }) => ({ ...state, redirectUrl })),
  on(SpaycialIntegrationActions.loadActivitiesSuccess, (state: State, { redirectUrl }) => ({ ...state, redirectUrl })),
  on(SpaycialIntegrationActions.loadOffersSuccess, (state: State, { redirectUrl }) => ({ ...state, redirectUrl })),
  on(SpaycialIntegrationActions.loadProfileSuccess, (state: State, { redirectUrl }) => ({ ...state, redirectUrl })),

  on(
    SpaycialIntegrationActions.connect,
    SpaycialIntegrationActions.loadConnections,
    SpaycialIntegrationActions.loadActivities,
    SpaycialIntegrationActions.disconnect,
    SpaycialIntegrationActions.loadStatus,
    SpaycialIntegrationActions.loadOffers,
    SpaycialIntegrationActions.loadProfile,
    (state: State) => ({ ...state, error: null }),
  ),
  on(
    SpaycialIntegrationActions.loadStatusFailure,
    SpaycialIntegrationActions.connectFailure,
    SpaycialIntegrationActions.loadConnectionsFailure,
    SpaycialIntegrationActions.loadActivitiesFailure,
    SpaycialIntegrationActions.disconnectFailure,
    SpaycialIntegrationActions.loadOffersFailure,
    SpaycialIntegrationActions.loadProfileFailure,
    (state: State, { error }) => ({ ...state, error }),
  ),
  on(SpaycialIntegrationActions.resetError, (state: State) => ({ ...state, error: null })),
  on(SpaycialIntegrationActions.resetRedirectUrl, (state: State) => ({ ...state, redirectUrl: null })),
);

export function reducer(state: State | undefined, action: Action): State {
  return reducers(state, action);
}
